// extracted by mini-css-extract-plugin
export default {"list":"styles_list__RPMmA","item":"styles_item__quAUW","name":"styles_name__k+Far","dob":"styles_dob__1PeNj"};